// extracted by mini-css-extract-plugin
export default {"card":"Styles_card__CmzR1","arrow":"Styles_arrow__VpxHN"};